import { useSearchParams } from 'react-router'

export function useReferenceTableQuery(sortKeys: string[]) {
  const [params, setParams] = useSearchParams()
  const requestedSort = params.get('sort') ?? 'name'
  const requestedPage = Number(params.get('page') ?? 1)
  const requestedSize = Number(params.get('pageSize') ?? 25)
  return {
    q: params.get('q') ?? '',
    sort: sortKeys.includes(requestedSort) ? requestedSort : sortKeys[0],
    direction:
      params.get('direction') === 'desc' ? ('desc' as const) : ('asc' as const),
    page:
      Number.isSafeInteger(requestedPage) && requestedPage > 0
        ? requestedPage
        : 1,
    pageSize: [25, 50, 100].includes(requestedSize) ? requestedSize : 25,
    update: (changes: Record<string, string | number | null>) => {
      setParams(
        (current) => {
          const next = new URLSearchParams(current)
          for (const [key, value] of Object.entries(changes)) {
            if (value == null || value === '') next.delete(key)
            else next.set(key, String(value))
          }
          return next
        },
        { replace: true }
      )
    }
  }
}
